import { ReactNode } from 'react';
import { APPOINTMENT_STATUSES } from 'constants/appointments';

import { TranslatableNote } from 'utils/translation';

export const ActionTypes = {
  TOGGLE_MODAL: 'TOGGLE_MODAL'
} as const;

export interface IUIProps {
  children: ReactNode;
}

export type ModalTypeItems<T = void> = {
  visible: boolean;
  params?: T;
};

type ConfirmParams = {
  onConfirm: () => void;
  title?: string;
  message?: string;
  confirmText?: string;
  type?: 'success' | 'danger';
};

type BlogDetailsParams = {
  blogId?: string;
};

type SpecialtyDetailsParams = {
  specialtyId?: string;
};

type RejectParams = {
  id: string;
  status:
    | typeof APPOINTMENT_STATUSES.canceled
    | typeof APPOINTMENT_STATUSES.rejected;
};

type DetailsParams = {
  id: string;
};

type TranslationType = {
  data?: TranslatableNote[] | null;
  appointment_id?: string | number;
};

type AuthTypes = {
  qr: string;
  secretCode: string;
};

type UploadPreviewType = {
  id: string;
  file: string;
  note: string;
};

type ReportPreviewType = {
  date: string;
  aboutDoctor: string;
  report: string;
  patientBirth: string;
  patientName: string;
  patientLastName: string;
  appointmentId: string;
  signature?: string;
  lang?: string | null;
  icd: {
    title: string;
    id: string;
  }[];
};

export type ModalParams =
  | ConfirmParams
  | BlogDetailsParams
  | SpecialtyDetailsParams
  | RejectParams
  | DetailsParams
  | TranslationType
  | AuthTypes
  | UploadPreviewType
  | ReportPreviewType;

export type ModalItem = {
  visible: boolean;
  params?: ModalParams;
};

export type ModalType = {
  confirm: ModalTypeItems<ConfirmParams>;
  blogDetails: ModalTypeItems<BlogDetailsParams>;
  specialtyDetails: ModalTypeItems<SpecialtyDetailsParams>;
  rejectAppointment: ModalTypeItems<RejectParams>;
  education: ModalTypeItems<DetailsParams>;
  experience: ModalTypeItems<DetailsParams>;
  certificate: ModalTypeItems<DetailsParams>;
  membership: ModalTypeItems<DetailsParams>;
  publication: ModalTypeItems<DetailsParams>;
  plans: ModalTypeItems<DetailsParams>;
  appointmentOption: ModalTypeItems<DetailsParams>;
  appointmentReport: ModalTypeItems<DetailsParams>;
  profile: ModalTypeItems;
  password: ModalTypeItems;
  services: ModalTypeItems;
  translation: ModalTypeItems<TranslationType>;
  authentication: ModalTypeItems<AuthTypes>;
  uploadPreview: ModalTypeItems<UploadPreviewType>;
  reportPreview: ModalTypeItems<ReportPreviewType>;
};

type ToggleModal = {
  type: typeof ActionTypes.TOGGLE_MODAL;
  data: { key: keyof ModalType; value: boolean; params?: ModalParams };
};

export type ModalState = ModalType;

export type State = {
  modal: ModalState;
};

export type Action = ToggleModal;

export type DispatchContext = {
  toggleModal: (
    key: keyof ModalType,
    value: boolean,
    params?: ModalParams
  ) => void;
};

export type Dispatch = (action: Action) => void;
